import {DataSourceConfig} from './data-source-config.model';
import {DefaultSchemaName} from '@app/views/admin/application-settings/models/data-source-config.model';
import {DataSourceFriendlyName, DataSourceType} from '@app/views/admin/application-settings/models/data-source-type.model';

export class SFTPConfig extends DataSourceConfig {
    // public hasPublicKey: boolean;
    public encryptSecretKeyTimestamp: Date = null;
    public encryptSecretKey = '';
    public rankOneDistrictList: RankOneDistrictItem[] | Error = <RankOneDistrictItem[]>[];
    public contactNamePattern: string;
    public isCreateFolderForEachSchool: boolean;

    constructor(
                public serverType: string = '',
                public host: string = '',
                public port: number = null,
                public username: string = '',
                public password: string = '',
                public remoteDirectory: string = '',
                public isCompressFiles: boolean = false,
                public archiveName: string = '',
                public isEmailNotification: boolean = false,
                public emailAddress: string = '',
                public isEncryptDataInFiles: boolean = false,
                public defaultSchemaName: DefaultSchemaName = <DefaultSchemaName>'',
                public friendlyName: string = DataSourceFriendlyName.SFTP,
                public rankOneDistrictId: string = '',
                public rankOneDistrictName: string = '',
                public isManuallyUpload: boolean = false,
                public isCreateProviderFolder?: boolean,
                public classlessInterDomainRouting?: string,
    ) {
        super(defaultSchemaName, friendlyName);
        this.dataSourceType = DataSourceType.SFTP;
    }
}

export class RankOneDistrictItem {
    id: string;
    name: string;
}

export const DEFAULT_SFTP_LOCALHOST_PORT = 9922;
